import { getDownloadURL, ref, uploadBytesResumable } from "firebase/storage";
import { useSelector } from "react-redux";
import { storage } from "../../firebase";

const FirebaseImageStore = ({ selectedFile, selectedFiles, functionCall }) => {
  const userData = useSelector((state) => state.userData.userData);

  const uploadSingleImage = (file) => {
    return new Promise((resolve, reject) => {
      if (!file) return resolve(null);

      const filePath = `images/${userData?.brand_auth}/${Date.now()}_${file.name}`;
      const storageRef = ref(storage, filePath);
      const uploadTask = uploadBytesResumable(storageRef, file);

      uploadTask.on(
        "state_changed",
        (snapshot) => {
          const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          console.log(`Uploading ${file.name}: ${progress.toFixed(0)}%`);
        },
        (error) => reject(error),
        async () => {
          try {
            const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
            resolve(downloadURL);
          } catch (error) {
            reject(error);
          }
        }
      );
    });
  };

  const uploadImages = async (draft) => {
    try {
      const bannerUploadPromise = selectedFile
        ? uploadSingleImage(selectedFile)
        : Promise.resolve(null);

      const productUploadPromises = selectedFiles && selectedFiles.length > 0
        ? Promise.all(selectedFiles.map(file => uploadSingleImage(file)))
        : Promise.resolve([]);

      const [bannerURL, productImages] = await Promise.all([
        bannerUploadPromise,
        productUploadPromises,
      ]);

      functionCall({ bannerURL, productImages }, draft);

    } catch (error) {
      console.error("Firebase upload failed:", error);
    }
  };

  return { uploadImages, uploadSingleImage };
};

export default FirebaseImageStore;
